async function createMetadataChart() {
	let response = await fetch(URL + 'list/virus')
	let data = await response.json();	

	const ptids = data.map(item => item.ptid);
	let myIds = []; myCohorts = []; finalIds = []

	//get information based on ptid
	for (id in ptids) {
		let myId = data[id].ptid;
		
		if (myIds.indexOf(myId) == -1) {
			myIds.push(myId);
			myCohorts.push(data[id].cohort)

			finalIds.push(ptids[Number(myIds[myId]-1)]);
		}
	}

	let { MC, SC, D1, D2, ER } = cohortCounts(myCohorts);

	let chartStatus = Chart.getChart("cohortchart");
	if (chartStatus != undefined) {
		chartStatus.destroy()
	} //end of destroying chart

	let ctx = document.getElementById("cohortchart").getContext('2d');
	window.myChart = new Chart(ctx, {
        	type: "pie",
        	data: {
			labels: ['Medical Center', 'High School', 'Daycare 1', 'Daycare 2', 'Emergency Department Staff'],
			datasets: [{
				backgroundColor: ['purple', 'blue', 'green', 'orange', 'red'],
				data: [ MC, SC, D1, D2, ER ]
			}]
		},
		options: { responsive: true,
            plugins: {
				title: { display: true,
							text: "Cohort Counts", font: { size: 20, weight: 'bold' }
                                } //title
					} //plugins
                          } //options
                        }); //end of chart
} //end of createMetadataChart()

function cohortCounts(myCohorts) {
	//count the size of each of the 5 cohorts
	let MC = 0; SC = 0; D1 = 0; D2 = 0; ER = 0; 

	for (i in myCohorts) {
		if (myCohorts[i] == "CU") {MC = MC + 1}
		else if (myCohorts[i] == "NV") {SC = SC + 1}
		else if (myCohorts[i] == "CUDC") {D1 = D1 + 1}
		else if (myCohorts[i] == "HS") {D2 = D2 + 1}
		else if (myCohorts[i] == "NYP") {ER = ER + 1}

	}
	return { MC, SC, D1, D2, ER }
}
